import React, { Component } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import _ from 'lodash'
import * as Constants from '../constants/constants'

import InputRange from 'react-input-range'
import { fileOptionsConstants } from '../constants/fileOptions'
import { removeExtraSlashes } from '../helper'
import caller from '../caller'
import InputBox from './InputBox'
import SelectionGroup from './SelectionGroup'

class Filters extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      searchQuery: {},
    }
  }

  componentDidMount() {
    this.setSearchQueryNew(JSON.stringify(this.props.searchQuery))
  }

  setSearchQueryNew = (query) => {
    this.setState({ searchQuery: JSON.parse(query) })
  }

  clearAllFilter = () => {
    const { searchQuery } = this.state
    const keepQuickSearchOnClearFilter = _.pick(searchQuery, 'quickSearch')
    this.setState(
      {
        searchQuery: keepQuickSearchOnClearFilter,
      },
      () => {
        this.props.onFilterChange(keepQuickSearchOnClearFilter)
      },
    )
  }

  getFileTypeIndex = (key, value) => {
    return Constants.constants.FileType.findIndex((t) => t[key] === value)
  }

  onFilterInputChange = (evt, key, type = '') => {
    const { searchQuery } = this.state
    if (type === 'size') {
      searchQuery.size = [evt.min, evt.max]
    } else if (type === 'checkbox') {
      searchQuery[key] = evt.target.checked
    } else if (key === 'fileType') {
      if (evt.target.defaultValue === 'All') {
        searchQuery[key] = ''
      } else {
        const selectedFileType = this.getFileTypeIndex(
          'value',
          evt.target.defaultValue,
        )
        searchQuery[key] = Constants.constants.FileType[selectedFileType].key
      }
    } else if (key === 'path') {
      const path = evt.target.value.trim()
      searchQuery[key] = path === '' ? '' : `/${path}`
    } else {
      searchQuery[key] = evt.target.value.trim()
    }
    this.setState({ searchQuery })
  }

  advancedFilterSubmit = (event) => {
    event.preventDefault()

    const { user } = this.props
    const { searchQuery } = this.state
    const removeFiltersWithEmptyValue = _.omitBy(
      searchQuery,
      (value) => value === '',
    )
    this.setState({ searchQuery: removeFiltersWithEmptyValue })
    const fptiFilterQuery = this.getFilterValueForFpti(
      removeFiltersWithEmptyValue,
    )

    caller.trackFPTI(user, fptiFilterQuery)
    this.props.onFilterChange(removeFiltersWithEmptyValue)
  }

  checkShareItemDisplay = (key) => {
    const { searchQuery } = this.state

    if (searchQuery.quickSearch && searchQuery.quickSearch === key) {
      return false
    }
    return true
  }

  getFilterValueForFpti = (appliedFilter) => {
    return _.reduce(
      appliedFilter,
      function (result, value, key) {
        result.push(key)
        if (key === 'path') {
          result.push(removeExtraSlashes(value))
        } else if (key === 'size') {
          result.push(`${value[0]},${value[1]}`)
        } else {
          result.push(value)
        }
        return result
      },
      ['search', 'filter'],
    )
  }

  renderAdvancedFilterOptions = () => {
    const { user } = this.props
    const { searchQuery } = this.state
    return (
      <ul className="ppvx_overflow-menu__list ppvx_overflow-menu__list--open filter__popover-container--advanced">
        <form
          className="filter__popover-content"
          onSubmit={this.advancedFilterSubmit}
        >
          <div
            className="filter__popover-box"
            style={{ flexDirection: 'column' }}
          >
            <div className="filter__advn-container">
              <div className="filter__advn-category-box">
                {Constants.constants[
                  `${
                    user.accType === Constants.constants.AdhocUser
                      ? 'AdvancedFilterAdhoc'
                      : 'AdvancedFilter'
                  }`
                ].map((item, index) => {
                  return (
                    this.checkShareItemDisplay(item.key) &&
                    this.renderAdvancedFilterInputTextBoxes(
                      item,
                      index,
                      searchQuery,
                    )
                  )
                })}

                {Constants.constants[
                  `${
                    user.accType === Constants.constants.AdhocUser
                      ? 'AdvancedFilterAdhoc'
                      : 'AdvancedFilter'
                  }`
                ].map((item, index) => {
                  return (
                    item.column === 3 && (
                      <div
                        className="filter__advn-category"
                        key={`${item.key}_${index}`}
                      >
                        <div className="filter__advn-label">
                          <div className="ppvx_text--md">
                            <Message id={`filter.${item.localizeId}`} />
                          </div>
                        </div>
                        {this.renderFilterSelectBox(item, searchQuery)}
                      </div>
                    )
                  )
                })}

                {Constants.constants[
                  `${
                    user.accType === Constants.constants.AdhocUser
                      ? 'AdvancedFilterAdhoc'
                      : 'AdvancedFilter'
                  }`
                ].map((item, index) => {
                  return (
                    item.column === 2 && (
                      <div
                        className="filter__advn-category"
                        key={`${item.key}_${index}`}
                      >
                        <div className="filter__advn-label">
                          <div className="ppvx_text--md">
                            <Message id={`filter.${item.localizeId}`} />
                            {item.key === 'size' ? ` (` : ''}
                            {item.key === 'size' ? (
                              <Message id={`filter.in`} />
                            ) : (
                              ''
                            )}
                            {item.key === 'size' ? ` GB)` : ''}
                          </div>
                        </div>
                        {item.key === 'size'
                          ? this.renderAdvancedFilterSizeRange(
                              item,
                              searchQuery,
                            )
                          : this.renderAdvancedFilterSwitchBox(
                              item,
                              searchQuery,
                            )}
                      </div>
                    )
                  )
                })}
              </div>
            </div>
            {this.renderAdvancedFilterActionButton(searchQuery)}
          </div>
        </form>
      </ul>
    )
  }

  renderAdvancedFilterSizeRange = (item, searchQuery) => {
    return (
      <div className="filter__advn-input--size-range">
        <InputRange
          draggableTrack
          maxValue={fileOptionsConstants.MaxSizeLimitForFilterInGB}
          minValue={0}
          onChange={(value) =>
            this.onFilterInputChange(value, item.key, 'size')
          }
          value={
            searchQuery[item.key]
              ? {
                  min: searchQuery[item.key][0],
                  max: searchQuery[item.key][1],
                }
              : { min: 0, max: fileOptionsConstants.MaxSizeLimitForFilterInGB }
          }
        />
      </div>
    )
  }

  renderAdvancedFilterInputTextBoxes = (item, index, searchQuery) => {
    let value = ''
    if (item.key === 'path') {
      value = searchQuery[item.key]
        ? removeExtraSlashes(searchQuery[item.key])
        : ''
    } else {
      value = searchQuery[item.key] ? searchQuery[item.key] : ''
    }
    return (
      item.column === 1 && (
        <div className="filter__advn-category" key={`${item.key}_${index}`}>
          <div className="filter__advn-label">
            <div className="ppvx_text--md">
              <Message id={`filter.${item.localizeId}`} />
            </div>
          </div>
          <div className="filter__advn-input">
            <div className="ppvx_text-input ppvx_text-input--nolabel">
              <InputBox
                name={item.key}
                id={item.key}
                value={value}
                className="input-box"
                label="Search files"
                isLabelHidden={true}
                placeholder={`filter.${item.localizeId}`}
                onChangeText={(e) => this.onFilterInputChange(e, item.key)}
                onKeyPressText={(e) => this.onFilterInputChange(e, item.key)}
                onBlurText={(e) => this.onFilterInputChange(e, item.key)}
                maxLength={200}
                autoFocus={false}
                style={{
                  border: '1px solid #b7bcbf',
                  padding: '10px',
                  color: '#2e2e2f',
                  fontSize: '14px',
                }}
              />
            </div>
          </div>
        </div>
      )
    )
  }

  renderAdvancedFilterSwitchBox = (item, searchQuery) => {
    return (
      <div className="filter__advn-input--switch">
        <div className="ppvx_switch">
          <input
            type="checkbox"
            className="ppvx_switch__control"
            id={item.key}
            checked={!!searchQuery[item.key]}
            onChange={(e) => this.onFilterInputChange(e, item.key, 'checkbox')}
          />
          <label className="ppvx_switch__state" htmlFor={item.key}>
            <span className="ppvx_switch__state--on">
              <Message id="filter.true" />
            </span>
            <span className="ppvx_switch__state--off">
              <Message id="filter.false" />
            </span>
          </label>
        </div>
      </div>
    )
  }

  renderFilterSelectBox = (item, searchQuery) => {
    let value = 'All'
    if (
      item.key === 'fileType' &&
      _.has(searchQuery, 'fileType') &&
      searchQuery[item.key] !== ''
    ) {
      value =
        Constants.constants.FileType[
          this.getFileTypeIndex('key', searchQuery[item.key])
        ].value
    }
    return (
      <div className="filter__advn-input" style={{ width: '270px' }}>
        <SelectionGroup
          name="filter_filetype"
          id="filter_filetype"
          label="Select file type"
          className="selection-menu"
          hideLabel={true}
          value={value}
          options={Constants.constants.FileType}
          onChange={(e) => this.onFilterInputChange(e, item.key)}
          style={{ fontSize: '14px', marginRight: '0' }}
        />
      </div>
    )
  }

  renderAdvancedFilterActionButton = (searchQuery) => {
    const { user } = this.props
    const searchKeys = Object.keys(searchQuery)
    _.remove(searchKeys, function (key) {
      return key === 'quickSearch'
    })

    return (
      <div className="filter__advn-button">
        <button className="ppvx_btn ppvx_btn--size_md flexCenter" type="submit">
          <span className="hide_mobile uploadButton">
            <Message id="filter.apply.button" />
          </span>
        </button>
        <button
          className={`ppvx_btn ppvx_btn--secondary ppvx_btn--size_md flexCenter ${
            searchKeys.length > 0 ? '' : 'disable__sec-button'
          }`}
          data-pa-pgrp={`dropzone:${user.accType}`}
          data-pa-page={`dropzone:search:clear_filter:${user.accType}`}
          data-pa-click="clear_filter"
          disabled={!searchKeys.length > 0}
          onClick={() => this.clearAllFilter()}
          type="button"
        >
          <span className="hide_mobile uploadButton">
            <Message id="filter.clear.all.button" />
          </span>
        </button>
      </div>
    )
  }

  render() {
    return this.renderAdvancedFilterOptions()
  }
}
export default Filters
